import React, { useState } from "react";
import {
  Alert,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Input,
  Option,
  Select,
  Stack,
  Textarea,
  Typography,
} from "@mui/joy";
import { api } from "../../../lib/api";
import { emailError, type SendOutcome } from "./emailWorkflows";
export function ReconcileEmailSend({
  send,
  onComplete,
}: {
  send: SendOutcome;
  onComplete: () => void;
}) {
  const [outcome, setOutcome] = useState("accepted");
  const [note, setNote] = useState("");
  const [messageId, setMessageId] = useState("");
  const [verified, setVerified] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const run = async () => {
    setBusy(true);
    setError("");
    try {
      await api.post(`/api/marketing/email-sends/${send.id}/reconcile/`, {
        outcome,
        note,
        provider_verified: verified,
        provider_message_id: messageId,
      });
      onComplete();
    } catch (cause) {
      setError(emailError(cause));
    }
    setBusy(false);
  };
  return (
    <Stack spacing={1}>
      <Typography level="title-md">Resolve uncertain delivery</Typography>
      <Alert color="warning">
        Verify the provider record first. Marking an accepted message “not
        accepted” and retrying could send a duplicate.
      </Alert>
      {error && <Alert color="danger">{error}</Alert>}
      <FormControl>
        <FormLabel>Verified outcome</FormLabel>
        <Select
          value={outcome}
          onChange={(_, value) => setOutcome(value || "accepted")}
        >
          <Option value="accepted">Accepted</Option>
          <Option value="not_accepted">Not accepted</Option>
        </Select>
      </FormControl>
      {outcome === "accepted" && (
        <FormControl>
          <FormLabel>Provider message ID</FormLabel>
          <Input
            value={messageId}
            onChange={(event) => setMessageId(event.target.value)}
          />
        </FormControl>
      )}
      <FormControl>
        <FormLabel>Evidence and notes</FormLabel>
        <Textarea
          minRows={2}
          value={note}
          onChange={(event) => setNote(event.target.value)}
        />
      </FormControl>
      <Checkbox
        checked={verified}
        onChange={(event) => setVerified(event.target.checked)}
        label="I verified this outcome in the provider’s records"
      />
      <Button
        loading={busy}
        disabled={
          !verified ||
          note.trim().length < 10 ||
          (outcome === "accepted" && !messageId.trim())
        }
        onClick={run}
      >
        Record verified outcome
      </Button>
    </Stack>
  );
}
